function getEnv(key) {
  if (typeof window !== 'undefined' && window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  return process.env[key];
}

const TOP_UP_URL = getEnv('REACT_APP_TOP_UP_URL');

export default async function prepaidTopUp(body) {
  if (!TOP_UP_URL) throw new Error('REACT_APP_TOP_UP_URL is not set.');

  const response = await fetch(TOP_UP_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body),
  });

  if (!response.ok) throw new Error(`Top Up HTTP ${response.status}`);
  return response.json();
}